import { CombatTutorial } from '@components/tutorial/CombatTutorial';
import { AbilityBar } from '@components/game/abilities/AbilityBar';
import { PlayerStats } from '@components/game/PlayerStats';
import { StartGame } from '@components/game/phaser/main';
import { MiniChat } from '@components/chat/MiniChat';
import { Glitch } from '@components/helpers/Glitch';
import { useGameStore, useAppStore } from '@stores';
import { useEffect, useRef } from 'react';

export function Combat() {
  const gameStarted = useRef(false);
  const { setIsLoading, isLoading } = useGameStore();
  const { userData } = useAppStore();

  useEffect(() => {
    if (!userData.id) return;

    if (gameStarted.current) return;
    gameStarted.current = true;

    setIsLoading(true);
    StartGame('game-container');
  }, [userData]);

  return (
    <>
      <PlayerStats />
      <CombatTutorial />

      <div className="relative w-full h-full" id="game-container">
        {isLoading && (
          <>
            <div className="absolute inset-0 bg-black opacity-[75%]" />
            <div className="absolute inset-0 flex items-center justify-center">
              <Glitch><span className="loader" /></Glitch>
            </div>
          </>
        )}

        <MiniChat />
      </div>
      <AbilityBar />
    </>
  );
}
